import React from 'react';

type Props = {};

const FaCancellationPolicy = (props: Props) => {
  return (
    <div className="text-red-1 text-14">
      Please note that this booking is subject to a cancellation fee in accordance with our cancellation policy:
      <br />
      <ul style={{ listStyle: 'disc', paddingLeft: 20 }}>
        <li style={{ listStyle: 'disc' }}>7-4 days before check-in: 20% of the first night's room charge</li>
        <li style={{ listStyle: 'disc' }}>3 days or less (within 72 hours) before check-in: 100% of the first night's room charge</li>
        <li style={{ listStyle: 'disc' }}>No-show: 100% of the total room charge for all nights</li>
      </ul>
      Once the cancellation process is complete, our team will contact you regarding the payment of the applicable cancellation fee.
    </div>
  );
};
export default FaCancellationPolicy;
